import { useEffect } from 'react';
import { ShieldAlert, LogOut } from 'lucide-react';
import { useCountdown, fmtClock, exitImpersonation, restoreStaff } from '../../lib/firmAccess';

// İSG uzmanı firma adına erişirken ekranın üstünde sabit kırmızı şerit
export const ImpersonationBanner = ({ info }) => {
  const left = useCountdown(info.expires_at);
  useEffect(() => {
    if (left === 0) restoreStaff('Firma erişim süresi doldu');
  }, [left]);

  return (
    <div className="fixed top-0 inset-x-0 z-[60] pointer-events-auto h-10 bg-red-600 text-white shadow-md flex items-center justify-center gap-3 px-3 text-xs sm:text-sm" data-testid="impersonation-banner">
      <ShieldAlert className="h-4 w-4 shrink-0 animate-pulse" />
      <span className="truncate">
        <b data-testid="impersonation-company">{info.company_name}</b> firması adına erişiyorsunuz
      </span>
      <span className="hidden sm:inline opacity-60">|</span>
      <span className="shrink-0">Kalan süre: <b className="font-mono tabular-nums" data-testid="impersonation-countdown">{fmtClock(left)}</b></span>
      <button
        type="button"
        onClick={exitImpersonation}
        className="ml-1 shrink-0 inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-xs font-semibold text-red-700 hover:bg-red-50 transition-colors"
        data-testid="impersonation-exit-btn"
      >
        <LogOut className="h-3.5 w-3.5" /> Çıkış
      </button>
    </div>
  );
};
